import { InsuranceCitizenship } from '../../../model/types'

export const filterCitizenships = (
  citizenships: InsuranceCitizenship[],
  search: string,
) => {
  const query = search.trim().toLocaleLowerCase()

  return citizenships.filter(({ name }) =>
    name.toLocaleLowerCase().includes(query),
  )
}
